/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Draftsconfirmapply2Inputs */



/**

* @param {_Wiki_Draftsconfirmapply2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_draftsconfirmapply2 = /** @type {((inputs?: _Wiki_Draftsconfirmapply2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Draftsconfirmapply2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Entwurf wirklich anwenden?")
});
export { _wiki_draftsconfirmapply2 as "_wiki_draftsConfirmApply" }